import axios from 'axios'
import {Raven} from 'vue-raven'

export const INBOX_FETCH_STATUS = 'INBOX_FETCH_STATUS'
export const INBOX_FETCH_COUNTERS = 'INBOX_FETCH_COUNTERS'
export const INBOX_SET_IS_SETUP = 'INBOX_SET_IS_SETUP'
export const INBOX_SET_COUNTERS = 'INBOX_SET_COUNTERS'
export const INBOX_DECREASE_UNREAD = 'INBOX_DECREASE_UNREAD'

export const INBOX_FETCH_LIST = 'INBOX_FETCH_LIST'
export const INBOX_SET_LIST = 'INBOX_SET_LIST'
// export const INBOX_SET_SELECTED = 'INBOX_SET_SELECTED'

const state = {
    inSetupInbox: true,
    inboxCounters: [],
    inboxes: []
    // selectedInbox: null,
}

const getters = {
    inboxes: state => state.inboxes,
    // selectedInbox: state => state.selectedInbox,
    inSetupInbox: state => state.inSetupInbox,
    inboxCounters: state => state.inboxCounters,
    inboxTotalUnread: state => _.sumBy(state.inboxCounters, 'count'),
    getInboxUnreadCount: state => uuid => {
        const idx = _.findIndex(state.inboxCounters, {inbox: uuid})
        return idx !== -1 ? state.inboxCounters[idx].count : 0
    }
}

const actions = {
    [INBOX_FETCH_STATUS]: ({commit}) => {
        return axios.get('inbox/is-setup')
            .then(res => {
                commit(INBOX_SET_IS_SETUP, res.status === 200)
            })
    },
    [INBOX_FETCH_COUNTERS]: ({commit}) => {
        return axios.get('inbox/counts')
            .then(res => {
                commit(INBOX_SET_COUNTERS, res.data || [])
            })
            .catch(e => {
                Raven.captureException(e)
            })
    },
    [INBOX_FETCH_LIST]: async({commit}) => {
        try {
            const response = await axios.get('inbox')

            let inboxes

            if (response.status === 200) {
                inboxes = response.data.data || []
            } else {
                throw Error(response.statusText)
            }

            commit(INBOX_SET_LIST, inboxes)

            return inboxes

            // if (!getters.selectedInbox && getters.inboxes.length !== 0) {
            // commit(INBOX_SET_SELECTED, res.data.data || [])
            // getters.selectedInbox = getters.inboxes.find(el => el.isDefault)
            // }
        } catch (e) {
            Raven.captureException(e)
        }
        return []
    }
}

const mutations = {
    [INBOX_SET_IS_SETUP]: (state, val) => {
        state.inSetupInbox = val
    },
    [INBOX_SET_COUNTERS]: (state, counters) => {
        state.inboxCounters = counters
    },
    [INBOX_DECREASE_UNREAD]: (state, inbox) => {
        const idx = _.findIndex(state.inboxCounters, {inbox})
        if (idx !== -1) {
            state.inboxCounters[idx].count -= 1
        }
    },
    [INBOX_SET_LIST]: (state, list) => {
        state.inboxes = list
    }
    // [INBOX_SET_SELECTED]: (state, inbox) => {
    //     state.selectedInbox = inbox
    // },
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}
